<template>
  <div class="row" style="padding-top: 20px">
    <div class="col-sm-10 col-sm-offset-1" style="background:white;border-radius:10px" v-if="business">
      <img :src="business.photoUrl" height="300px" style="border-radius:10px;margin-top:10px"/>
      <h3>{{business.name}}</h3>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4"
        style="margin-bottom:20px"
        v-for="item in items"
        :key="item.label">
          <label>{{item.label}}</label>
          <p class="itemValue">{{item.value}}</p>
        </div>
      </div>

    <br>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { StoreActions } from "./store/actions";
import StoreIndex from "./store/_StoreIndex";
import {StoreState as state} from './store/state'
export default {
  name: "Business",
  components: {
  },
  data() {
    return {
      showReportedPosts: false,
      showReportedComments: false,
      showReported: false,
      showPosts: false,
      showComments: false,
      showDeletedPosts: false,
      filter: "",
      deletedFilter: ""
    };
  },
  mounted() {
      this.get()
  },
  destroyed() {
    this.dispatch(StoreActions.clearState);
  },
  methods: {
    commit(path, value) {
      this.$store.commit(`${StoreIndex.path}/${path}`, value);
    },
    dispatch(path, value) {
      this.$store.dispatch(`${StoreIndex.path}/${path}`, value);
    },
    get() {
      let id = this.$route.params.id
      this.dispatch(StoreActions.get,id);
    },
    parseValue(val) {
      if(!val) {
        return ""
      }

      return val
    }
  },
  computed: {
    ...mapState(StoreIndex.path,[
      state.business
    ]),
    items() {
      if(!this.business) {
        return []
      }
      return [
        {
          label:'Name',
          value: this.parseValue(this.business.name)
        },
        {
          label:'Type',
          value:this.parseValue(this.business.type)
        },
        {
          label:'Street',
          value:this.parseValue(this.business.street)
        },
        {
          label:'City',
          value:this.parseValue(this.business.city)
        },
        {
          label:'State',
          value:this.parseValue(this.business.state)
        },
        {
          label:'Zip',
          value:this.parseValue(this.business.zip)
        },
        {
          label:'Country',
          value:this.parseValue(this.business.country)
        },
        {
          label:'Lat',
          value:this.parseValue(this.business.lat)
        },
        {
          label:'Lng',
          value:this.parseValue(this.business.lng)
        },
        {
          label:'Website',
          value:this.parseValue(this.business.website)
        },
        {
          label:'Bio',
          value:this.parseValue(this.business.bio)
        },
        {
          label:'Needs Review',
          value:this.parseValue(this.business.needsReview)
        },
        {
          label:'Rejection Reason',
          value:this.parseValue(this.business.rejectionReason)
        },
        {
          label:'Approved',
          value: `${this.business.approved ? 'Yes' : 'No'}`
        },
        {
          label:'Boosted',
          value: `${this.business.boosted ? 'Yes' : 'No'}`
        },
        {
          label:'List Views',
          value: `${this.business.listViews}`
        },{
          label:'Detail Views',
          value: `${this.business.detailViews}`
        },{
          label:'Link Views',
          value: `${this.business.linkViews}`
        }
      ]
    }
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

label {
  color:gray;
}

.itemValue {
  color:black;
  font-size: medium;
}
</style>
